import moment from "moment";
function removeCurrentYearAndFormat(now) {
    return this.format("YYYY") === moment(now._d).format("YYYY") ? 'MMM DD [at] h:mm A' : 'MMM DD, YYYY [at] h:mm A';
}
function removeCurrentYearAndFormatFilter(now) {
    return this.format("YYYY") === moment(now._d).format("YYYY") ? 'MMM DD' : 'MMM DD, YYYY';
}
function removeCurrentYearAndFormatFullMonth(now) {
    return this.format("YYYY") === moment(now._d).format("YYYY") ? 'MMMM Do [at] h:mm A' : 'MMMM Do, YYYY [at] h:mm A';
}
export var DOWNLOAD_FORMATE = "MM/DD/YYYY h:mm A";
export var MOMENT_CALENDER = {
    sameDay: '[Today] [at] h:mm A',
    nextDay: removeCurrentYearAndFormat,
    nextWeek: removeCurrentYearAndFormat,
    lastDay: '[Yesterday] [at] h:mm A',
    lastWeek: removeCurrentYearAndFormat,
    sameElse: removeCurrentYearAndFormat
};
export var MOMENT_CALENDER_FILTER = {
    sameDay: '[Today]',
    nextDay: removeCurrentYearAndFormatFilter,
    nextWeek: removeCurrentYearAndFormatFilter,
    lastDay: '[Yesterday]',
    lastWeek: removeCurrentYearAndFormatFilter,
    sameElse: removeCurrentYearAndFormatFilter
};
export var MOMENT_CALENDER_FULL_MONTH = {
    sameDay: '[Today] [at] h:mm A',
    nextDay: removeCurrentYearAndFormatFullMonth,
    nextWeek: removeCurrentYearAndFormatFullMonth,
    lastDay: '[Yesterday] [at] h:mm A',
    lastWeek: removeCurrentYearAndFormatFullMonth,
    sameElse: removeCurrentYearAndFormatFullMonth
};
//# sourceMappingURL=calender.js.map